/**
 * State used in rendering Toast
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
